import { Box, Container, IconButton, Stack, Tooltip, Typography, useTheme, } from "@mui/material";
import { GridViewIcon, RecommendationViewIcon } from "./selection-icons.js";
import { match } from "ts-pattern";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import { ViewGrid } from "./view-grid.js";
import { ViewMobileCompact } from "./view-mobile-compact.js";
import { ViewRecommendation } from "./view-recommendation.js";
import React from "react";
export const ProductSelection = ({ id = "product-selection", featuredParagraphs, featuredProductId, featuredTitle, products = [], recommendedProductIds, sectionContainer = {}, isDesktop, showPrice = true, }) => {
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const bgColor = theme.palette.grey[50];
    const isAtleastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const inDesktopMode = isDesktop ?? isAtleastSm;
    const isTouchDevice = useMediaQuery("(hover: none)");
    const [currentView, setCurrentView] = React.useState("recommendation");
    const wrapWithTooltip = (n, title) => isTouchDevice ? (n) : (React.createElement(Tooltip, { arrow: true, title: title }, n));
    return (React.createElement(Box, { component: "section", id: id, sx: {
            backgroundColor: bgColor,
            boxShadow: "sectionBottom",
            position: "relative",
            zIndex: 10,
            ...sectionContainer,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: { pt: { xs: 8, sm: 8, lg: 14 }, pb: 0 } },
            React.createElement(Stack, { alignItems: "center", justifyContent: "space-between", direction: "row", spacing: 2, sx: { width: "100%" } },
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "h2", sx: { pb: 0.5 } }, inDesktopMode
                        ? t("selection-headline-long", "Das Krimidinner für Zuhause")
                        : t("selection-headline-short", "Krimidinner für Zuhause"))),
                inDesktopMode && products.length > 5 && (React.createElement(Stack, { direction: "row", spacing: { xs: 0, lg: 1 }, alignItems: "center" },
                    wrapWithTooltip(React.createElement(IconButton, { sx: {
                            fontSize: { xs: "2rem", lg: "2.25rem", xl: "2.5rem" },
                            color: currentView === "recommendation"
                                ? theme.palette.action.active
                                : theme.palette.action.disabled,
                        }, size: "large", onClick: () => setCurrentView("recommendation") },
                        React.createElement(RecommendationViewIcon, { fontSize: "inherit", sx: { color: "inherit" } })), t("selection-view-recommendation", "Unsere Empfehlung")),
                    wrapWithTooltip(React.createElement(IconButton, { size: "large", onClick: () => setCurrentView("grid"), sx: {
                            fontSize: { xs: "2rem", lg: "2.25rem", xl: "2.5rem" },
                            color: currentView === "grid"
                                ? theme.palette.action.active
                                : theme.palette.action.disabled,
                        } },
                        React.createElement(GridViewIcon, { fontSize: "inherit", sx: { color: "inherit" } })), t("selection-view-details", "Detailansicht")))))),
        !inDesktopMode && (React.createElement(ViewMobileCompact, { featuredParagraphs: featuredParagraphs, featuredProductId: featuredProductId, featuredTitle: featuredTitle, products: products, recommendedProductIds: recommendedProductIds, showPrice: showPrice })),
        inDesktopMode && (React.createElement(Container, { maxWidth: "xl", sx: { pt: { xs: 6, lg: 6, xl: 10 }, pb: { xs: 6, sm: 8, lg: 12 } } }, match(currentView)
            .with("recommendation", () => (React.createElement(ViewRecommendation, { featuredParagraphs: featuredParagraphs, featuredProductId: featuredProductId, featuredTitle: featuredTitle, products: products, recommendedProductIds: recommendedProductIds, showPrice: showPrice })))
            .with("grid", () => React.createElement(ViewGrid, { products: products }))
            .with("table", () => null)
            .exhaustive()))));
};
//# sourceMappingURL=product-selection.js.map